var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _path13, _g3, _path14, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationBrokenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F5F9",
    fillRule: "evenodd",
    d: "M275.143 103.669c15.001 37.365-66.536 71.673-103.139 74.596-36.498 3.07-104.298 7.375-150.582-40.478C-24.731 89.757 7.98 3.285 112.184 39.674c104.287 36.49 148.051 26.751 162.959 63.995Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 277,
    height: 150,
    x: 0,
    y: 30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M275.143 103.669c15.001 37.365-66.536 71.673-103.139 74.596-36.498 3.07-104.298 7.375-150.582-40.478C-24.731 89.757 7.98 3.285 112.184 39.674c104.287 36.49 148.051 26.751 162.959 63.995Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2EAF5",
    fillRule: "evenodd",
    d: "M139.5 133.452c2.499 0 4.525-2.043 4.525-4.563 0-2.52-2.026-4.563-4.525-4.563-2.499 0-4.525 2.043-4.525 4.563 0 2.52 2.026 4.563 4.525 4.563Z",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    fillRule: "evenodd",
    d: "M60.118 78.982v5.415L57.624 92.5l2.494 7.795L57 104.766l3.118 7.524L154.764 150 171 145.17l-7.171-34.905-8.205-2.805 1.352-59.682L60.118 35v43.982Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "m156.968 47.822-1.062 59.522 8.043 2.782-8.298 3.562 9.234 10.144-9.674 8.723L155 150l62-18.691v-11.201l-3.745-1.26 3.745-2.641v-9.82l-2.809-.934 2.809-1.558V31l-60.032 16.822Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "m60 35 97.108 13L217 31.286 115.948 22 60 35Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CADBDD",
    fillRule: "evenodd",
    d: "M156.961 48 186 28.5 100.852 22 60.247 35l96.714 13Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#95B1C9",
    fillRule: "evenodd",
    d: "m172 35-92-6.154L97.854 23 172 35Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    fillRule: "evenodd",
    d: "M119.108 20 80 21.875 171.989 35 217 31.25 119.108 20Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#95B1C9",
    fillRule: "evenodd",
    d: "M183.343 105.19c-.935.31-28.047 8.074-28.047 8.074l-35.613-9.208 36.15 5.59 27.51-4.456ZM183.343 121.65c-.935.311-28.047 10.249-28.047 10.249l-95.05-31.679 95.673 27.331 27.424-5.901Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M173.328 43.54c.666 2.64.043 21.586.043 21.586l29.917-8.075-.165-21.896-29.795 8.386Z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#95B1C9",
    fillRule: "evenodd",
    d: "M217 106.432h-10.284c.623 0 7.479-.932 7.479-.932l2.805.932ZM217 120.097s-11.531-.311-10.284 0c1.246.311 6.544-1.242 6.544-1.242l3.74 1.242ZM203.288 63.573l-28.982 9.006v13.976l28.982-9.317V63.573Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m182.49 82.616-2.081.672-.208-11.001 2.08-.672.209 11ZM183.669 82.234l-.694.225-.208-11.001.693-.225.209 11.001ZM187.413 81.024l-.693.225-.209-11.002.693-.224.209 11.001ZM186.234 81.405l-2.08.673-.209-11.002 2.08-.672.209 11.001ZM179.751 83.5l-.346.113-.209-11.001.346-.112.209 11ZM189.112 80.475l-.347.112-.208-11.001.346-.112.209 11.001ZM193.238 79.141l-2.08.673-.209-11.001 2.08-.673.209 11.001ZM194.417 78.76l-.694.225-.208-11.001.693-.225.209 11.001ZM198.161 77.55l-.693.224-.209-11.001.693-.224.209 11.001ZM196.982 77.931l-2.08.672-.209-11 2.081-.673.208 11.001ZM190.499 80.027l-.346.112-.209-11.001.346-.112.209 11ZM199.86 77l-.347.113-.208-11.001.346-.112.209 11Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#95B1C9",
    fillRule: "evenodd",
    d: "m60.247 84.381 25.242 9.938-26.299-6.518 1.057-3.42Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 29,
    height: 29,
    x: 122,
    y: 53,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M122.181 65.692c0 7.869 6.379 15.02 14.247 15.972 7.869.952 14.249-4.655 14.249-12.524 0-7.869-6.38-15.02-14.249-15.971a14.4 14.4 0 0 0-1.729-.106c-7.054 0-12.518 5.346-12.518 12.63Zm13.911 1.451-.136-.153c-.781-.874-.781-2.143-.001-2.83l3.485-3.062c.378-.332.881-.48 1.415-.415a2.273 2.273 0 0 1 1.415.757l1.318 1.477c.779.874.779 2.144-.001 2.83l-3.484 3.063c-.379.332-.881.48-1.416.414a2.269 2.269 0 0 1-1.414-.756l-.137-.154-.371.327.136.152c.781.875.781 2.144 0 2.83l-3.484 3.063c-.378.333-.88.48-1.415.415a2.27 2.27 0 0 1-1.415-.757l-1.317-1.477c-.78-.874-.78-2.144-.001-2.83l3.486-3.062c.377-.333.88-.48 1.414-.415a2.27 2.27 0 0 1 1.415.757l.137.152.371-.326Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005454",
    fillRule: "evenodd",
    d: "m121.706 50.912 29.445 3.563V83.92l-29.445-3.563V50.913Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 6,
    height: 6,
    x: 130,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m133.664 68.305-3.445 3.027c-.201.178-.201.506 0 .731l1.303 1.46c.195.22.535.26.731.09l3.444-3.029c.202-.177.202-.505 0-.731l-.135-.151-.666.586-1.033-1.158.666-.586-.134-.15a.593.593 0 0 0-.429-.2.452.452 0 0 0-.302.111Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005454",
    fillRule: "evenodd",
    d: "m129.599 67.193 6.718.812v6.715l-6.718-.813v-6.714Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 6,
    height: 6,
    x: 137,
    y: 62,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m140.605 62.172-3.444 3.206c-.201.188-.201.535 0 .774l.135.16 1.021-.951 1.033 1.226-1.021.951.134.16c.196.231.536.275.732.093l3.444-3.206c.201-.187.201-.534 0-.773l-1.302-1.546a.578.578 0 0 0-.428-.212.438.438 0 0 0-.304.118Z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005454",
    fillRule: "evenodd",
    d: "m136.541 60.994 6.719.86v7.11l-6.719-.86v-7.11Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationBrokenLink);
export default __webpack_public_path__ + "static/media/illustration-broken-link.4b4dea85d735821baaf96b7e15401d1c.svg";
export { ForwardRef as ReactComponent };